module.exports = require("@swa-ui/currency/src/Currency/Currency.module.scss");